import { render } from "./PointManagement.vue?vue&type=template&id=5ccd41de"
import script from "./PointManagement.vue?vue&type=script&lang=js"
export * from "./PointManagement.vue?vue&type=script&lang=js"

import "./PointManagement.vue?vue&type=style&index=0&id=5ccd41de&lang=scss"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__